interface Props {
  columns: JSX.Element[];
  ratio?: number[];
}

export const ListHead = (props: Props): JSX.Element => {
  const { columns } = props;
  return (
    <tr>
      {columns.map((elem, index) => (
        <th key={index} className="pb-4">
          {elem}
        </th>
      ))}
    </tr>
  );
};
